import React from "react";
import {connect} from "react-redux";
import {Text, View, StyleSheet, TouchableOpacity} from "react-native";
import AvatarIcon from "../../Header/AvatarIcon";
import moment from "moment";

class PostComment extends React.Component{

    constructor(props) {
        super(props);
    }

    capitalize(str){
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    formatCommentaire(){

    }

    // Exammple format: "2021-06-25T09:28:00"
    _getDateFormat(date){
        let today = moment();
        let m  = moment.utc(date);
        let d = today.unix() - m.unix() ;
        let t = {label : 'h', v : "hours"};

        if(d<60){
            t = {label : 's', v : "seconds"};
        }else if (d<3600){
            t = {label : 'min', v : "minutes"};
        }else if (d<86400){
            t = {label : 'h', v : "hours"};
        }else if(d<604800){
            t = {label : 'j', v : "days"};
        }else{
            t = false;
        }

        let diff, formatted;
        if (t !== false) {
            diff = today.diff(m,t.v);
            formatted = diff + " " + t.label;
        } else {
            formatted = diff = m.local().format("DD/MM/Y");
        }

        return {value: diff, unit: t, formatted};
    }

    render() {
        const styles = StyleSheet.create({
            container :{
                flexDirection:"row",
            },
            commentContainer :{
                width:"95%",
                backgroundColor:this.props.theme.colors.tertiary.grey3.value,
                borderRadius:7,
                padding:14,
                borderTopLeftRadius:2
            },
            commentHeaderContainer:{
                flexDirection:"row",
                justifyContent:"space-between",
            },
            commentName :{
                fontFamily:this.props.theme.fonts.title,
                fontSize:14,
                color : this.props.theme.colors.tertiary.black1.value
            },
            commentDate:{
                color : this.props.theme.colors.tertiary.black6.value,
                fontSize:12,
                fontFamily:this.props.theme.fonts.text,
            },
            commentText:{
                fontFamily:this.props.theme.fonts.text,
                fontSize:14,
                color : this.props.theme.colors.tertiary.black1.value,
                marginTop:5
            },

        });

        const comment = this.props.comment;
        const date = this._getDateFormat(comment.inserted_at);

        return (<View style={{marginVertical:20,marginRight:20,marginLeft:0}}>
            <View style={styles.container}>
                <AvatarIcon  style={styles.icon} icon={comment.user.img} style={{width:35,height:35,borderRadius: 12,marginRight:10}} isHeader={false}/>
                <View style={styles.commentContainer}>
                    <View style={styles.commentHeaderContainer}>
                        <Text style={styles.commentName}>{this.capitalize(comment.user.firstname) } {this.capitalize(comment.user.lastname)}</Text>
                        <Text style={styles.commentDate}>{ date.formatted }</Text>
                    </View>
                    <Text style={styles.commentText}>
                        { comment.body.map((item, index) =>{
                            if(item.type == 'mention'){
                                return <TouchableOpacity key={index} onPress={()=>this.props.navigateToProfil(item.user_id)}>
				  <Text style={{color:this.props.theme.colors.primary.blue1.value}}>
				    {item.content + " "}
				  </Text>
				</TouchableOpacity>;
                            }else{
                                return <Text key={index}>{item.content+ " "}</Text>;
                            }
                        }) }
                    </Text>
                </View>
            </View>
        </View>);
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default connect(mapStateToProps)(PostComment);
